<div class="box" [class.box--payroll]="mode === 'PAYROLL_CONFIG'" [class.box--reprog]="mode === 'REPROGRAMACION'">
  <div class="header" *ngIf="mode !== 'REPROGRAMACION' && mode !== 'ENTRY_EXIT_DETAIL' && mode !== 'PAYROLL_CONFIG'">
    <div class="content" [ngClass]="'greendAnalityco'">
      {{ dialogTitle }}
    </div>
  </div>

  <!-- ── PRENOMINA MODE ── -->
  <ng-container *ngIf="mode === 'PRENOMINA'">
    <div class="content-card list-card">
      <div class="title-card">
        SELECCIONAR<br>
        FORMATO DE DESCARGA
      </div>
      <div class="option-row">
        <div class="option" (click)="selectedFormat = 'horizontal'">
          <span class="option-label">Excel horizontal</span>
          <span class="option-radio" [class.option-radio--selected]="selectedFormat === 'horizontal'"></span>
        </div>
        <div class="option" (click)="selectedFormat = 'vertical'">
          <span class="option-label">Excel vertical por lugar de trabajo</span>
          <span class="option-radio" [class.option-radio--selected]="selectedFormat === 'vertical'"></span>
        </div>
        <div class="option" (click)="selectedFormat = 'verticalByProjectComp'">
          <span class="option-label">Excel vertical por lugar de trabajo-comp</span>
          <span class="option-radio" [class.option-radio--selected]="selectedFormat === 'verticalByProjectComp'"></span>
        </div>
        <div class="option" (click)="selectedFormat = 'verticalByProject'">
          <span class="option-label">Excel vertical por proyecto</span>
          <span class="option-radio" [class.option-radio--selected]="selectedFormat === 'verticalByProject'"></span>
        </div>
        <div class="option" (click)="selectedFormat = 'verticalByCompProject'">
          <span class="option-label">Excel vertical por proyecto-comp</span>
          <span class="option-radio" [class.option-radio--selected]="selectedFormat === 'verticalByCompProject'"></span>
        </div>
      </div>
    </div>
    <div class="btn-actions">
      <button mat-button class="btn-cancelar" (click)="close()">CANCELAR</button>&nbsp;&nbsp;
      <button mat-button class="btn-generar" (click)="save()">DESCARGAR</button>
    </div>
  </ng-container>

  <!-- ── PAYROLL CONFIG MODE ── -->
  <ng-container *ngIf="mode === 'PAYROLL_CONFIG'">
    <div class="pc-shell">

      <div class="pc-header">
        <div class="pc-header-icon"><mat-icon>event_available</mat-icon></div>
        <div class="pc-header-title">Configuración de Periodos</div>
        <button type="button" class="pc-header-close" (click)="close()">
          <mat-icon>close</mat-icon>
        </button>
      </div>

      <div class="pc-body">

        <div class="pc-section-title">
          <div class="pc-section-icon"><mat-icon>event</mat-icon></div>
          <span>Creación automática de periodos</span>
        </div>

        <div class="pc-row">
          <label class="pc-row-label">
            Tipo de periodo
            <mat-icon class="pc-help-icon"
                      matTooltip="Catorcenal: periodos de 14 días. Quincenal: del 1 al 15 y del 16 a fin de mes. Mensual: del 1 a fin de mes.">
              help_outline
            </mat-icon>
          </label>
          <mat-form-field appearance="outline" class="pc-select">
            <mat-select [(ngModel)]="periodType" placeholder="Seleccionar tipo de periodo">
              <mat-option *ngFor="let pt of periodTypes" [value]="pt.value">{{ pt.label }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="pc-row">
          <label class="pc-row-label">Iniciar a partir de</label>
          <div class="pc-date-wrapper">
            <mat-icon class="pc-date-icon-outer">event</mat-icon>
            <div class="pc-date-field" (click)="pickerCreationStart.open()">
              <input class="pc-date-input" [matDatepicker]="pickerCreationStart" [(ngModel)]="creationStartDate"
                     (dateChange)="onCreationStartDateChange()" placeholder="Seleccionar fecha" readonly>
              <mat-datepicker #pickerCreationStart></mat-datepicker>
            </div>
          </div>
        </div>

        <div class="pc-row">
          <label class="pc-row-label">Estado del periodo</label>
          <mat-form-field appearance="outline" class="pc-select">
            <mat-select [(ngModel)]="periodState" placeholder="Seleccionar estado">
              <mat-option value="OPEN">Abierto</mat-option>
              <mat-option value="CLOSED">Cerrado</mat-option>
            </mat-select>
          </mat-form-field>
        </div>

        <div class="pc-row">
          <label class="pc-row-label">Estado (Inactivo/Activo)</label>
          <div class="pc-toggle">
            <mat-slide-toggle
              [(ngModel)]="isCreationEnabled"
              [disabled]="!canEnableCreation"
              matTooltip="Selecciona la fecha de inicio para poder activarlo"
              [matTooltipDisabled]="canEnableCreation">
            </mat-slide-toggle>
            <span class="pc-toggle-text" [class.pc-toggle-text--on]="isCreationEnabled">{{ isCreationEnabled ? 'Activo' : 'Inactivo' }}</span>
          </div>
        </div>

        <div class="pc-divider"></div>

        <div class="pc-section-title">
          <div class="pc-section-icon pc-section-icon--lock"><mat-icon>lock</mat-icon></div>
          <span>Cierre automático de periodos</span>
        </div>

        <div class="pc-row">
          <label class="pc-row-label">Días hábiles para el cierre</label>
          <div class="pc-stepper">
            <input class="pc-stepper-input" type="number" min="0" [(ngModel)]="closingBusinessDays"
                   (ngModelChange)="onClosingBusinessDaysChange()" (keydown)="blockNegativeKey($event)">
            <div class="pc-stepper-arrows">
              <button type="button" (click)="incClosingBusinessDays()"><mat-icon>keyboard_arrow_up</mat-icon></button>
              <button type="button" (click)="decClosingBusinessDays()"><mat-icon>keyboard_arrow_down</mat-icon></button>
            </div>
          </div>
        </div>

        <div class="pc-row">
          <label class="pc-row-label">Estado (Inactivo/Activo)</label>
          <div class="pc-toggle">
            <mat-slide-toggle
              [(ngModel)]="isClosingEnabled"
              [disabled]="!canEnableClosing"
              matTooltip="Ingresa los días hábiles para poder activarlo"
              [matTooltipDisabled]="canEnableClosing">
            </mat-slide-toggle>
            <span class="pc-toggle-text" [class.pc-toggle-text--on]="isClosingEnabled">{{ isClosingEnabled ? 'Activo' : 'Inactivo' }}</span>
          </div>
        </div>

        <div class="pc-divider"></div>

        <div class="pc-row pc-row--icon">
          <div class="pc-section-icon pc-section-icon--clock"><mat-icon>schedule</mat-icon></div>
          <label class="pc-row-label pc-row-label--grow">Máximo de Horas Extras por periodo</label>
          <div class="pc-stepper">
            <input class="pc-stepper-input" type="number" min="0" [(ngModel)]="maxExtraHours"
                   (ngModelChange)="onMaxExtraHoursChange()" (keydown)="blockNegativeKey($event)">
            <div class="pc-stepper-arrows">
              <button type="button" (click)="incMaxExtraHours()"><mat-icon>keyboard_arrow_up</mat-icon></button>
              <button type="button" (click)="decMaxExtraHours()"><mat-icon>keyboard_arrow_down</mat-icon></button>
            </div>
          </div>
        </div>

        <div class="pc-divider"></div>

        <div class="pc-section-title pc-section-title--days">
          <div class="pc-section-icon"><mat-icon>event</mat-icon></div>
          <span>Día límite de la semana para la revisión de horas extras</span>
        </div>

        <div class="pc-days">
          <div class="pc-day" *ngFor="let day of weekdays; let i = index" (click)="toggleDay(i)">
            <button type="button" class="pc-day-btn" [class.pc-day-btn--selected]="isDaySelected(i)">
              {{ day.substring(0, 3).toUpperCase() }}
            </button>
            <span class="pc-day-name" [class.pc-day-name--selected]="isDaySelected(i)">{{ day }}</span>
          </div>
        </div>

        <div class="pc-warning">
          <mat-icon class="pc-warning-icon">warning</mat-icon>
          <span>Si al finalizar el día seleccionado existen horas pendientes de aprobación al día anterior. Se restringirá el acceso a la jornada siguientes del día seleccionado.</span>
        </div>
      </div>

      <div class="pc-footer">
        <button mat-button class="pc-btn-cancel" (click)="close()">CANCELAR</button>
        <button mat-button class="pc-btn-save" (click)="save()">
          <mat-icon>save</mat-icon>&nbsp;GUARDAR
        </button>
      </div>

    </div>
  </ng-container>


  <!-- ── REPROGRAMACION MODE ── -->
  <ng-container *ngIf="mode === 'REPROGRAMACION'">
    <div class="repr-shell">

      <!-- ═══ LOADING OVERLAY ═══ -->
      <div class="repr-loading-overlay" *ngIf="reprLoading">
        <mat-spinner diameter="36"></mat-spinner>
        <span>Cargando datos...</span>
      </div>

      <!-- ═══ INFO HEADER (light) ═══ -->
      <div class="repr-info-header">
        <div class="repr-status-row">
          <span class="repr-status-label-text">Estado:</span>
          <span class="repr-status-pill"
                [ngStyle]="{'color': reprStatusColor, 'background': reprStatusBg, 'border': '1px solid ' + reprStatusColor + '55'}">
            <mat-icon class="repr-status-icon">schedule</mat-icon>
            {{ reprStatusLabel }}
          </span>
          <span *ngIf="reprIsLocked" class="repr-locked-badge">
            <mat-icon class="repr-locked-icon">lock</mat-icon>
            Solo lectura
          </span>
        </div>
        <div class="repr-employee-name">{{ reprPersonName }}</div>
        <div class="repr-employee-date">{{ reprFormattedDate }}</div>
      </div>

      <div class="repr-rule"></div>

      <!-- ═══ TITLE ═══ -->
      <div class="repr-main-title">REPROGRAMACIÓN</div>

      <!-- ═══ SECTION 1: HORA DE ENTRADA ═══ -->
      <div class="repr-section-header">
        <span class="repr-section-number">1</span>
        <span class="repr-section-label">Modificación de hora de entrada programada</span>
      </div>
      <div class="repr-grid-card">
        <div class="repr-grid-head">
          <div class="repr-gh-label"></div>
          <div class="repr-gh-col">Programado</div>
          <div class="repr-gh-col">Reprogramación</div>
        </div>
        <!-- Entrada — editable -->
        <div class="repr-grid-row">
          <div class="repr-grid-row-label">
            <mat-icon class="repr-row-icon repr-row-icon--entry">login</mat-icon>
            Entrada
          </div>
          <div class="repr-grid-cell">{{ reprShortDate }} {{ toShortTime(reprScheduledEntry) }}</div>
          <div class="repr-grid-cell repr-grid-cell--input">
            <div class="repr-cell-date-time">
              <span class="repr-date-prefix">{{ reprShortDate }}</span>
              <input *ngIf="!reprIsLocked" type="time" class="repr-time-input"
                     [ngModel]="reprEntry"
                     (ngModelChange)="reprEntry = $event; onReprEntryChange()" />
              <span *ngIf="reprIsLocked" class="repr-time-readonly">{{ toShortTime(reprEntry) }}</span>
            </div>
            <span *ngIf="reprEntryStatus !== 'fijo'" class="repr-chip" [ngClass]="'repr-chip--' + reprEntryStatus">
              Modificado
            </span>
          </div>
        </div>
        <div class="repr-grid-divider"></div>
        <!-- Salida — siempre solo lectura -->
        <div class="repr-grid-row">
          <div class="repr-grid-row-label">
            <mat-icon class="repr-row-icon repr-row-icon--leave">logout</mat-icon>
            Salida
          </div>
          <div class="repr-grid-cell">{{ reprShortDate }} {{ toShortTime(reprScheduledLeave) }}</div>
          <div class="repr-grid-cell repr-grid-cell--input">
            <div class="repr-cell-date-time">
              <span class="repr-date-prefix">{{ reprShortDate }}</span>
              <span class="repr-time-readonly repr-time-readonly--muted">{{ toShortTime(reprLeave) }}</span>
            </div>
            <span *ngIf="reprLeaveStatus !== 'fijo'" class="repr-chip" [ngClass]="'repr-chip--' + reprLeaveStatus">
              {{ reprLeaveStatus === 'recalc' ? 'Recalculado' : 'Modificado' }}
            </span>
          </div>
        </div>
      </div>

      <!-- ═══ SECTION 2: DESCANSO ═══ -->
      <div class="repr-section-header">
        <span class="repr-section-number">2</span>
        <span class="repr-section-label">Modificación de tiempo de descanso programada</span>
      </div>
      <div class="repr-grid-card">
        <div class="repr-grid-head repr-grid-head--3col">
          <div class="repr-gh-label"></div>
          <div class="repr-gh-col">Programado</div>
          <div class="repr-gh-col">Reprogramación</div>
        </div>
        <div class="repr-grid-row repr-grid-row--3col">
          <div class="repr-grid-row-label">
            <mat-icon class="repr-row-icon repr-row-icon--break">coffee</mat-icon>
            Descanso (hr)
          </div>
          <div class="repr-grid-cell">
            {{ toShortTime(reprBreakScheduled) || '—' }}
          </div>
          <div class="repr-grid-cell repr-grid-cell--input">
            <input *ngIf="!reprIsLocked" type="text" class="repr-time-input repr-break-input"
                   placeholder="ej: 01:00"
                   [(ngModel)]="reprBreak" />
            <span *ngIf="reprIsLocked" class="repr-time-readonly">{{ reprBreak || '—' }}</span>
            <span *ngIf="reprBreakStatus !== 'fijo'" class="repr-chip" [ngClass]="'repr-chip--' + reprBreakStatus">
              Modificado
            </span>
          </div>
        </div>
      </div>

      <div class="repr-rule" style="margin: 8px 0;"></div>

      <!-- ═══ TOTALS ═══ -->
      <div class="repr-totals-card">
        <div class="repr-grid-head repr-grid-head--totals">
          <div class="repr-totals-title">TOTALES</div>
          <div class="repr-gh-col">Programado</div>
          <div class="repr-gh-col">Reprogramación</div>
        </div>
        <!-- Jornada -->
        <div class="repr-grid-row repr-grid-row--totals">
          <div class="repr-grid-row-label">
            <mat-icon class="repr-totals-icon">schedule</mat-icon>
            Jornada (hr)
          </div>
          <div class="repr-grid-cell">{{ reprJornadaScheduled }}</div>
          <div class="repr-grid-cell repr-grid-cell--input">
            <span class="repr-total-value"
                  [class.repr-total-value--changed]="reprJornadaStatus === 'recalc'">
              {{ reprJornadaExcepcion }}
            </span>
            <span *ngIf="reprJornadaStatus !== 'fijo'" class="repr-chip repr-chip--sm" [ngClass]="'repr-chip--' + reprJornadaStatus">
              Recalculado
            </span>
          </div>
        </div>
        <div class="repr-totals-divider"></div>
        <!-- Trabajadas -->
        <div class="repr-grid-row repr-grid-row--totals">
          <div class="repr-grid-row-label">
            <mat-icon class="repr-totals-icon">work_history</mat-icon>
            Trabajadas (hr)
          </div>
          <div class="repr-grid-cell">{{ reprTrabajadasScheduled }}</div>
          <div class="repr-grid-cell repr-grid-cell--input">
            <span class="repr-total-value">{{ reprTrabajadasExcepcion }}</span>
          </div>
        </div>
      </div>

      <!-- ═══ INFO NOTE ═══ -->
      <div class="repr-info-note">
        <mat-icon class="repr-info-icon">info</mat-icon>
        <span>* Las excepciones no modifican el total de horas trabajadas en el turno.</span>
      </div>

      <!-- ═══ COMENTARIO ═══ -->
      <div class="repr-comment-box">
        <label class="repr-comment-label">Comentario</label>
        <textarea class="repr-comment-textarea"
          rows="3"
          placeholder="Escribe un comentario (opcional)..."
          [disabled]="reprIsLocked"
          [(ngModel)]="reprComment"
          maxlength="500"></textarea>
        <span class="repr-comment-counter">{{ (reprComment?.length || 0) }}/500</span>
      </div>

      <!-- ═══ ACTIONS ═══ -->
      <div class="repr-actions">
        <button mat-button class="repr-btn-cancel" [disabled]="reprSaving" (click)="close()">CANCELAR</button>
        <button *ngIf="!reprIsLocked" mat-button class="repr-btn-save"
                [disabled]="reprSaving || reprLoading"
                (click)="save()">
          <mat-spinner *ngIf="reprSaving" diameter="18" style="display:inline-block;margin-right:6px;"></mat-spinner>
          {{ reprSaving ? 'GUARDANDO...' : 'GUARDAR' }}
        </button>
      </div>

    </div>
  </ng-container>

  <!-- ── ENTRY_EXIT_DETAIL MODE ── -->
  <ng-container *ngIf="mode === 'ENTRY_EXIT_DETAIL'">
    <div class="content-card eid-card">

      <!-- Person + Date header -->
      <div class="eid-person-header">
        <img class="eid-person-photo" [src]="data.personalRow?.PhotoUrl" alt="foto" />
        <div>
          <div class="eid-person-name">{{ reprPersonName }}</div>
          <div class="eid-date">{{ reprFormattedDate }}</div>
        </div>
      </div>

      <!-- Shift row -->
      <div class="eid-schedule-row" *ngIf="data.personalRow?.WorkShiftName">
        <mat-icon style="font-size:14px;height:14px;width:14px;color:#94a3b8;vertical-align:middle;">schedule</mat-icon>
        &nbsp;<span class="eid-schedule-text">Turno: {{ data.personalRow?.WorkShiftName }}</span>
      </div>

      <div class="eid-rule"></div>

      <!-- ENTRADA -->
      <div class="eid-section-title eid-section-title--entry">
        <mat-icon>login</mat-icon>
        ENTRADA
      </div>
      <div class="eid-detail-rows">
        <div class="eid-row">
          <span class="eid-label">Hora registrada</span>
          <span class="eid-value" [class.eid-value--missing]="!data.personalRow?.OriginalEntryTime">
            {{ data.personalRow?.OriginalEntryTime ? formatTimePeriod(data.personalRow?.OriginalEntryTime) : 'Sin registro' }}
          </span>
        </div>
        <div class="eid-row" *ngIf="data.personalRow?.EntryTime">
          <span class="eid-label">Tipo de registro</span>
          <span class="eid-value">
            <span *ngIf="data.personalRow?.EntryTimeManuallyEdited" class="eid-badge eid-badge--manual">Editado manualmente</span>
            <span *ngIf="!data.personalRow?.EntryTimeManuallyEdited" class="eid-badge eid-badge--auto">Automático</span>
          </span>
        </div>
        <div class="eid-row" *ngIf="data.personalRow?.EntryUsers">
          <span class="eid-label">Registrado por</span>
          <span class="eid-value">{{ data.personalRow?.EntryUsers }}</span>
        </div>
        <div class="eid-row" *ngIf="data.personalRow?.EntryProjects">
          <span class="eid-label">Lugar de trabajo</span>
          <span class="eid-value">{{ data.personalRow?.EntryProjects }}</span>
        </div>
      </div>

      <div class="eid-rule"></div>

      <!-- SALIDA -->
      <div class="eid-section-title eid-section-title--leave">
        <mat-icon>logout</mat-icon>
        SALIDA
      </div>
      <div class="eid-detail-rows">
        <div class="eid-row">
          <span class="eid-label">Hora registrada</span>
          <span class="eid-value" [class.eid-value--missing]="!data.personalRow?.OriginalLeaveTime">
            {{ data.personalRow?.OriginalLeaveTime ? formatTimePeriod(data.personalRow?.OriginalLeaveTime) : 'Sin registro' }}
          </span>
        </div>
        <div class="eid-row" *ngIf="data.personalRow?.LeaveTime">
          <span class="eid-label">Tipo de registro</span>
          <span class="eid-value">
            <span *ngIf="data.personalRow?.LeaveTimeManuallyEdited" class="eid-badge eid-badge--manual">Editado manualmente</span>
            <span *ngIf="!data.personalRow?.LeaveTimeManuallyEdited" class="eid-badge eid-badge--auto">Automático</span>
          </span>
        </div>
        <div class="eid-row" *ngIf="data.personalRow?.LeaveUsers">
          <span class="eid-label">Registrado por</span>
          <span class="eid-value">{{ data.personalRow?.LeaveUsers }}</span>
        </div>
        <div class="eid-row" *ngIf="data.personalRow?.LeaveProjects">
          <span class="eid-label">Lugar de trabajo</span>
          <span class="eid-value">{{ data.personalRow?.LeaveProjects }}</span>
        </div>
      </div>

      <!-- Close footer -->
      <div class="eid-footer">
        <button mat-button class="btn-cancelar" (click)="close()">CERRAR</button>
      </div>

    </div>
  </ng-container>

</div>

